/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, Collapse, styled } from '@mui/material';
import React from 'react';
import { colors } from '@farmlands/mui-theme';
import MaterialSymbol from '../../../components/MaterialSymbol';
import Typography from '../../../components/Typography';
import TestIds from '../../../testIds';

const HelperCollapse = styled(Collapse)(({ theme }) => ({
  background: theme.colors.secondary100,
  color: theme.colors.secondary800,
}));

const CollapseContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

interface HelperMessageProps {
  show: boolean;
}
const UrgentDeliveryUnavailableMessage: React.FC<HelperMessageProps> = ({ show }) => {
  return (
    <HelperCollapse in={show} data-testid={TestIds.feat.stock.urgentDeliveryBanner}>
      <Box display='flex' alignItems={'center'} px={2}>
        <MaterialSymbol color={colors.secondary800}>deployed_code_alert</MaterialSymbol>
        <CollapseContainer>
          <Typography variant='body2' color={'secondary800'} fontWeight='bold'>
            Urgent delivery unavailable
          </Typography>

          <Typography variant='caption' color={'secondary800'} fontWeight='regular'>
            You can still order this item, but it can’t be delivered urgently.
          </Typography>
        </CollapseContainer>
      </Box>
    </HelperCollapse>
  );
};

export default UrgentDeliveryUnavailableMessage;
